import { DateTime } from 'luxon';
export var partition = function (arr, callback) {
    return arr.reduce(function (acc, e) {
        acc[callback(e) ? 0 : 1].push(e);
        return acc;
    }, [[], []]);
};
export var getDateRelatedToState = function (invoice) {
    var _a, _b, _c;
    if (invoice.state === 'finalized')
        return (_a = invoice.finalized_on) !== null && _a !== void 0 ? _a : '';
    else if (invoice.state === 'processed')
        return (_b = invoice.processed_on) !== null && _b !== void 0 ? _b : '';
    else if (invoice.state === 'settled')
        return (_c = invoice.settled_on) !== null && _c !== void 0 ? _c : '';
    else
        return invoice.created_on;
};
export var CUT_OFF_DAY = 1; // first of every month
export var getLocalInvoiceDates = function () {
    var now = DateTime.fromJSDate(new Date());
    var cutOffDate = DateTime.fromObject({
        day: CUT_OFF_DAY,
        month: now.month + 1,
        year: now.year,
    });
    return {
        now: now,
        cutOffDate: cutOffDate,
    };
};
